<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        locale="ru-RU"
        readonly
        v-bind="attrs"
        v-on="on"
        :label="$t('rates.date')"
        :rules="[isRequired]"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :locale="$i18n.locale"
      :allowed-dates="proccessDates"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    date: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    proccessDates(date) {
      return new Date() >= new Date(date);
    },
  },
  created() {
    const date = new Date();
    const formatNum = (v) => (v < 10 ? `0${v}` : v);

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    this.date = `${formatNum(year)}-${formatNum(month)}-${formatNum(day)}`;
  },
};
</script>

<style></style>
